import { useScreenSlideIn } from '@/hooks/useScreenSlideIn';
import styles from './index.module.scss';
import card1Img from '@/assets/productCenter/ai/ai-screen3-card1.png';
import card2Img from '@/assets/productCenter/ai/ai-screen3-card2.png';
import card3Img from '@/assets/productCenter/ai/ai-screen3-card3.png';
import dotBlue from '@/assets/productCenter/ai/ai-screen3-blue.png';
import dotGreen from '@/assets/productCenter/ai/ai-screen3-green.png';
import dotPurple from '@/assets/productCenter/ai/ai-screen3-purple.png';
import curveImg from '@/assets/productCenter/ai/ai-screen3-curve.png';

const SCROLL_CONTAINER = '[data-scroll-root="aixue-ai-scroll"]';

const CARDS = [
  {
    figure: card1Img,
    title: '精细测定，多维能力',
    desc: '基于专业大纲和个人学情等多维测定手段，即时调整教授策略，精准学习薄弱知识',
  },
  {
    figure: card2Img,
    title: '分步引导，智能讲授',
    desc: '自研数字人结合爱学大模型，实现AI导师对问题针对性地分步耐心讲解',
  },
  {
    figure: card3Img,
    title: '及时回顾，完全掌握',
    desc: '通过学习报告及时回顾学习情况，对知识点掌握和学习互动进行直观展示，原汁原味复现学习现场',
  },
];

export default function Screen3() {
  const slideInRef = useScreenSlideIn({
    scrollContainerSelector: SCROLL_CONTAINER,
    triggerSlideRatio: 0.65,
    animationClassName: styles['screen3-anim'],
    triggerOnce: false,
  });

  return (
    <section className={styles['screen3-cover']} ref={slideInRef.ref}>
      <div className={styles['screen-top-content']}>
        <h2 className={styles['screen-top-title']}>专属级的个性化学习</h2>
        <p className={styles['screen-top-desc']}>
          尊重每一位学习者"个体"，构建专属的个性化学习链路
        </p>
      </div>

      <div className={styles['screen3-cards-wrap']}>
        {CARDS.map((card, i) => (
          <div
            key={i}
            className={`${styles['screen3-card']} ${styles[`screen3-card-${i}`]}`}
            style={{ backgroundImage: `url(${card.figure})` }}
          >
            <div className={styles['screen3-card-body']}>
              <h3 className={styles['screen3-card-title']}>{card.title}</h3>
              <p className={styles['screen3-card-desc']}>{card.desc}</p>
            </div>
          </div>
        ))}
      </div>

      <div className={styles['screen3-curve-wrap']}>
        <div className={styles['screen3-curve-slide-wrap']}>
          <img
            className={styles['screen3-curve-img']}
            src={curveImg}
            alt=""
            aria-hidden
            loading="lazy"
          />
        </div>
        <div className={styles['screen3-dots-slide-wrap']}>
          <div className={`${styles['screen3-dots']} ${styles['screen3-dots-top']}`}>
            <span className={styles['screen3-dot-slot']} />
            <span
              className={`${styles['screen3-dot']} ${styles['screen3-dot-blue']}`}
              style={{ backgroundImage: `url(${dotBlue})` }}
            />
            <span className={styles['screen3-dot-slot']} />
          </div>
          <div className={`${styles['screen3-dots']} ${styles['screen3-dots-bottom']}`}>
            <span
              className={`${styles['screen3-dot']} ${styles['screen3-dot-green']}`}
              style={{ backgroundImage: `url(${dotGreen})` }}
            />
            <span className={styles['screen3-dot-slot']} />
            <span
              className={`${styles['screen3-dot']} ${styles['screen3-dot-purple']}`}
              style={{ backgroundImage: `url(${dotPurple})` }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
